import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Layout from "../src/components/common/Layout";

import Login from "./Pages/Login/Login";
import { LoaderProvider } from "./Context/ContextFunctions";

import SettingList from "./Pages/Setting/SettingList";
import ReportList from "./Pages/Report/ReportList";
import AddUpdateCustomer from "./Pages/Customer/AddUpdateCustomer";
import CustomerDetaills from "./Pages/Customer/CustomerDetaills";
import ServiceJobType from "./Pages/Setting/ServiceJobType/ServiceJobType";
import NotificationList from "./Pages/Notification/Notification";
import Configure from "./Pages/Configure/Configure";
import ActivityLogPage from "./components/common/ActivityLog";
import TemplatePage from "./Pages/EmailTemplate/AddUpdateEmailTemplate";

const App = () => {
  const Dashboard = lazy(() => import("./Pages/Dashboard/Dashboard"));
  const CustomerList = lazy(() => import("./Pages/Customer/CustomerList"));
  const SubscriptionsList = lazy(() =>
    import("./Pages/Subscriptions/SubscriptionsList")
  );
  const Logout = lazy(() => import("./Pages/Login/Login"));

  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <LoaderProvider>
          <Routes>
            {/* Routes that need Layout */}
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/customer" element={<CustomerList />} />
                    <Route
                      path="/AddUpdateCustomer"
                      element={<AddUpdateCustomer />}
                    />
                    <Route path="/report" element={<ReportList />} />
                    <Route path="/setting" element={<SettingList />} />
                    <Route
                      path="/subscriptions"
                      element={<SubscriptionsList />}
                    />
                    <Route
                      path="/customer-details"
                      element={<CustomerDetaills />}
                    />
                    <Route
                      path="/service-job-type"
                      element={<ServiceJobType />}
                    />
                    <Route
                      path="/notification"
                      element={<NotificationList />}
                    />
                    <Route path="/configure" element={<Configure />} />
                    <Route path="/activity" element={<ActivityLogPage />} />
                    <Route
                      path="/add-update-template"
                      element={<TemplatePage />}
                    />
                  </Routes>
                </Layout>
              }
            />

            {/* Separate Routes for Login and Logout */}
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
          </Routes>
        </LoaderProvider>
      </Suspense>
    </Router>
  );
};

export default App;
